export default __webpack_public_path__ + "static/media/navbar-icon-active-promotions.5ab30ec0.svg";